import { render, staticRenderFns } from "./Refer.vue?vue&type=template&id=0b9eabbf&scoped=true&"
import script from "./Refer.vue?vue&type=script&lang=js&"
export * from "./Refer.vue?vue&type=script&lang=js&"
import style0 from "./Refer.vue?vue&type=style&index=0&id=0b9eabbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9eabbf",
  null
  
)

export default component.exports